////// SUBHEADER HELPERS //////
import moment from 'moment';


export function getHourTime(h) {
  return h >= 12 ? 'PM' : 'AM'
}

export function formatTime(h, m){
  m = parseInt(m);
  h = parseInt(h);
  h = h % 12;
  if(h === 0){
    h = 12;
  }
  if(h < 10 && h !== '00'){
    h = '0' + h;
  }
  if(m < 10 && m !== '00'){
    m = '0' + m;
  }
  return h + ':' + m;
}

export function getFormattedDate(){
  return new Date().toDateString();
}

////// END SUBHEADER //////

///// SITE HELPERS ///////

//To be used in conjuction with formatTime. Gets hour and minutes from string
export function formatTimeStr(str){
  var s = str.split(':');
  var h = s[0];
  var m = s[1];
  
  return {h:h, m:m}
}

export function addTime(time1, time2){
  var t1 = moment(time1);
  var t = t1.add(time2, 'hours');
  
  return t.toDate().toTimeString();
}

export function getNearestHalfHour(){
    var now = new Date();
    //var hour = now.getHours();
    var minutes = now.getMinutes();
    if (minutes < 15) {
        minutes = "00";
    } else if (minutes < 45){
        minutes = "30";
    } else {
        minutes = "00";
        now.setHours(now.getHours() + 1);
    }
    now.setMinutes(minutes);
    return(now);
}

export function convertTo24Hr(time){
  //Converting from 12hr time to 24hr time. Should be in formate of HH:MMPM/AM
  var ampm = time.match(/[A-Za-z]+/)[0];
  var hours = Number(time.match(/^(\d+)/)[1]);
  var minutes = Number(time.match(/:(\d+)/)[1]);
  if(ampm.toLowerCase() == "pm" && hours<12) hours = hours+12;
  if(ampm.toLowerCase() == "am" && hours==12) hours = hours-12;
  var sHours = hours.toString();
  var sMinutes = minutes.toString();
  if(hours<10) sHours = "0" + sHours;
  if(minutes<10) sMinutes = "0" + sMinutes;
  
  return sHours + ':' + sMinutes;
}

///// END SITE //////

//// CONSUMPTION ////
export function getFirstDayOfWeek(date){
  var day = date.getDay() || 7;
  if( day !== 1 ) {
    date.setHours(-24 * (day - 1));
  }
  date.setUTCHours(0, 0, 0);
  return date;
}

export function getLastDayOfWeek(date){
  var day = date.getDay() || 7;
  if( day !== 7 ) {
    date.setHours(24 * (7 - day - 1));
  }
  date.setUTCHours(23, 59, 59);
  return date;
}

export function getFirstDayOfMonth(date){
  date = new Date(date.getFullYear(), date.getMonth(), 1);
  date.setUTCHours(0, 0, 0);
  return date;
}

export function getLastDayOfMonth(date){
  date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  date.setUTCHours(23, 59, 59);
  return date;
}


// WEBPACK FOOTER //
// ./src/javascript/helpers.js